export const LeftToFixQueue = {
    INDUCT_QUEUE: "INDUCT_QUEUE",
    SORTATION_QUEUE: "SORTATION_QUEUE",
    PICK_AND_STAGE_QUEUE: "PICK_AND_STAGE_QUEUE",
    DISPATCH_QUEUE: "DISPATCH_QUEUE",
    ALL_CATEGORY_QUEUE: "ALL_CATEGORY_QUEUE"
}